<p-panel header="  {{'pages_titles.vehicles.add' | translate}}">
<app-loader *ngIf="loadingSpinner"></app-loader>

    <form (ngSubmit)="onCreateClick()"  *ngIf="!loadingSpinner">
        <div class="row ml-3 mr-3">

            <!--Matriculation-->
            <div class="col-12 col-md-6">
                <label for="licensePlate">{{'LicensePlate' | translate}}<span class="text-danger">*</span></label>
                <input class="w-100" pInputText id="licensePlate" name="licensePlate" placeholder="{{'num_matriculate'| translate}}"
                    (input)="handleLicensePlate($event)" required type="text" [formControl]="licensePlateControl" />
                <ng-container
                    *ngIf="(licensePlateControl.invalid || isLicensePlateUsed) && (licensePlateControl.dirty || isSubmitted  || licensePlateControl.touched)">
                    <p class="text-danger space" *ngIf="licensePlateControl?.errors?.required">
                        {{'errors.licensePlate.required' | translate}}
                    </p>
                    <p class="text-danger space" *ngIf="isLicensePlateUsed">
                        {{'errors.licensePlate.used' | translate}}
                    </p>
                </ng-container>
            </div>

            <!--Marque-->
            <div class="col-12 col-md-6">
                <label for="brand">{{'Brand' | translate}}<span class="text-danger">*</span></label>
                <p-dropdown appendTo="body" [options]="brands" name="brands" [(ngModel)]="electricVehicle.brand" optionLabel="name" optionValue="_id"
                (onChange)="onChangeBrand($event)" ></p-dropdown>
            </div>

            <!--Model-->
            <div class="col-12 col-md-6 mt-2">
                <label for="model">{{'Model' | translate}}<span class="text-danger">*</span></label>
                <p-dropdown appendTo="body" [options]="models" name="models" [(ngModel)]="electricVehicle.model" optionLabel="name" optionValue="_id"></p-dropdown>
            </div>

            <!--Usages-->
            <div class="col-12 col-md-6 mt-2">
                <label for="employee">{{'user' | translate}}</label>
                <p-dropdown appendTo="body"  [options]="employees" name="employees" [(ngModel)]="electricVehicle.user" optionLabel="username" optionValue="id"
                (onChange)="onChangeSelect($event)"></p-dropdown>

            </div>

            <div class="ml-auto mr-auto mt-4">
                <button pButton  icon="pi pi-check" iconPos="left" (click)="onCreateClick()"
                 type="button" label="{{'actions.add' | translate}}" ></button>
            </div>
        </div>
    </form>
    <!--End Form-->
</p-panel>